import { createFileRoute } from "@tanstack/react-router"
import { AdminCompaniesPanel } from "@/components/directory-admin/admin-companies-panel"

export const Route = createFileRoute("/_authed/admin/companies")({
  component: AdminCompaniesPanel,
})
